module.exports = __webpack_public_path__ + "img/wind.f752c16c.svg";